import { FC } from 'react';
import './top5.scss';
import { ApiRunner, RaceDatas, RunnerPosition } from '../types';
import { Nump } from './nump';

/* -------------------------------------------------------------------------------- *\
|                               Top5Props
\* -------------------------------------------------------------------------------- */
interface Top5Props
{
    competitors: ApiRunner[],
	racedatas: RaceDatas | null,
    top5: RunnerPosition[],
	children?: Node
}
/* -------------------------------------------------------------------------------- *\
|                               Top5
\* -------------------------------------------------------------------------------- */
export const Top5 : FC<Top5Props> = ({competitors, racedatas, top5}) =>
{
    const first = top5.length > 0 ? (top5[0].smoothspeed !== 0 ? top5[0].smoothspeed :top5[0].speed) : 0;
    const speeds = top5.map((x) => (x.smoothspeed !== 0 ? x.smoothspeed : x.speed) - first);
    const colors = speeds.map((x) =>
    {
        const d = Math.abs(x);
        if (d < 3 / 3.6) return "top5__row__white";
        return x < 0 ? "top5__row__red" : "top5__row__green";
    });
    return (
        <div className='top5'>
            <div className='top5__row top5__row__header'>
                <div className='top5__row__position'>Rank</div>
                <div className='top5__row__number'>#</div>
                <div className='top5__row__name'>Name</div>
                <div className='top5__row__eprm'>Dist/1st</div>
                <div className='top5__row__speed'>Speed</div>
                <div className='top5__row__speedvs1st'>Speed vs 1st</div>
                <div className='top5__row__avgspeed'>Avg speed</div>
                {
                    (racedatas && racedatas.hrs) ?
                    <div className='top5__row__eprm'>HR</div>
                    : <></>
                }
            </div>
            {
                top5.map((position: RunnerPosition, index: number) =>
                {
                    const valid = !position.state || position.state === "DP";
                    return (
                        <div className='top5__row' key={'row_0' + index}>
                            <div className='top5__row__position'>{index + 1}</div>
                            <div className='top5__row__number'>
                                <div className='top5__row__number__cont'>
                                    <Nump number={position.number} size={18} />
                                </div>
                            </div>
                            <div className='top5__row__name'>{competitors[position.number]?.name}</div>

                            {
                                valid &&
                                (
                                    <>
                                        <div className='top5__row__eprm'>{index === 0 ? "" : (Math.floor(position.eprm * 10) / 10).toFixed(1)}</div>
                                        <div className='top5__row__speed'>
                                            <div>{position.speed > 0 ? (Math.floor(position.speed * 3.6 * 10) / 10).toFixed(1) : ""}</div>
                                        </div>
                                        <div className={'top5__row__speedvs1st ' + colors[index]}>
                                            <div>{(racedatas?.started && index > 0) ? (Math.floor(speeds[index] * 3.6 * 10) / 10).toFixed(1) : ""}</div>
                                        </div>
                                        <div className='top5__row__avgspeed'>
                                            <div>{position.avgspeed > 0 ? (Math.floor(position.avgspeed * 3.6 * 10) / 10).toFixed(1) : ""}</div>
                                        </div>
                                    </>
                                )
                            }
                            {
                                !valid &&
                                (
                                    <>
                                        <div className='top5__row__eprm'>{position.state}</div>
                                        <div className='top5__row__speed'></div>
                                        <div className='top5__row__speedvs1st'></div>
                                        <div className='top5__row__avgspeed'></div>
                                    </>
                                )
                            }
                        </div>
                        )
                    }
                )
            }
        </div>
    );
}
